module.exports = __webpack_public_path__ + "eddc8ab5d9f9534d7fd2aa277c65c6a1.png";